import { ca } from '@cian/analytics';

import { TJsonQuery } from 'packages/JsonQuery';

export const trackServicePlaceClick = (jsonQuery: TJsonQuery, position: number, source?: string) => {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'Mortgage_banner',
    page: {
      extra: {
        position,
        trap_type: 'mortgage',
        bannerName: 'Выгодные ставки по ипотеке',
        source,
      },
    },
    searchConditions: jsonQuery,
  });
};

export const trackServicePlaceShow = (jsonQuery: TJsonQuery, position: number, source?: string) => {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'Mortgage_banner',
    page: {
      extra: {
        position,
        trap_type: 'mortgage',
        bannerName: 'Выгодные ставки по ипотеке',
        source,
      },
    },
    searchConditions: jsonQuery,
  });
};
